// API action
export const SET_LOADING = "SET_LOADING";

// Push action
export const SET_RATE_LIST = "SET_RATE_LIST";
export const SET_PUSH_ERROR = "SET_PUSH_ERROR";
